<template>
  <div class="categories">
    <template v-for="(category, catId) in categories">
      <h3 :key="catId" class="flc">
        <svg xmlns="http://www.w3.org/2000/svg" width="12.969" height="18" viewBox="0 0 12.969 18" fill="#666"><path d="M745.289,326.375h-3.545a5.2,5.2,0,0,1,3.191-5.175,4.126,4.126,0,0,0,1.063-.675,1.374,1.374,0,0,0,.237-1.575,2.775,2.775,0,0,0-2.718-1.575,2.8,2.8,0,0,0-2.955,2.587l-3.545-.45a6.4,6.4,0,0,1,6.5-5.512,6.488,6.488,0,0,1,6.026,3.6,4.592,4.592,0,0,1-.945,5.287,9.021,9.021,0,0,1-1.89,1.238A2.189,2.189,0,0,0,745.289,326.375Zm0.591,3.375a2.366,2.366,0,1,1-2.363-2.25A2.307,2.307,0,0,1,745.88,329.75Z" transform="translate(-737.031 -314)"></path></svg>
        {{category.title}}
      </h3>
      <template v-for="article in articles(catId)">
        <span
          @click="showArticle"
          :data-article="article.id"
          :class="{active: activeArticle == article.id}"
          :key="article.id"
          :style="{transition:  colTrans}"
        >
          <img
            :style="{transition:  widTrans, width: arrowWidth(article.id)}"
            class="rotate"
            src="https://s3.amazonaws.com/csx-previews/single-page-support/images/arrow.svg"
          >
          {{ article.title }}
        </span>
        <div
          :key="article.id+'0'"
          class="article-text"
          :class="{active: artActive(article.id)}"
          v-html="article.body"
          :id="'art-'+article.id"
        ></div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    name
  },
  data() {
    return {
      openArticleIds: [],
      activeArticle: '',
      colTrans: 'color .3s',
      widTrans: 'width .3s'
    };
  },
  methods: {
    arrowWidth(artId) {
      return this.activeArticle === `${artId}` ? '19px' : '0px';
    },
    artActive(artId) {
      return this.activeArticle === `${artId}`;
    },
    articles(categoryId) {
      const articlesArray = this.$store.state.articles[categoryId];
      return articlesArray;
    },
    showArticle(e) {
      if (this.activeArticle === e.target.dataset.article) {
        document.querySelector(`#art-${e.target.dataset.article}`).style['max-height'] = '0px';
        this.activeArticle = '';
        return;
      } else if (this.activeArticle) {
        document.querySelector(`#art-${this.activeArticle}`).style['max-height'] = '0px';
      }
      document.querySelector(`#art-${e.target.dataset.article}`).style['max-height'] = '1200px';

      this.activeArticle = e.target.dataset.article;
    }
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

[data-article] .rotate {
  transform: rotate(90deg);
  height: 15px;
}

.article-text {
  display: block;
  max-height: 0px;
  overflow-y: hidden;
  font-size: 15px;
  margin-bottom: 5px;
  line-height: 1.5;
  color: #676767;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-transition: max-height 0.3s cubic-bezier(0, 1, 0, 1); /* For Safari 3.1 to 6.0 */
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
  padding-left: 5px;
  transition: max-height 0.3s, padding-bottom 0.3s;
  padding-bottom: 0px;
}

h3.flc {
  line-height: 1.5;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  color: #0a0a0a;
}

.article-text.active {
  -webkit-transition: max-height 0.3s; /* For Safari 3.1 to 6.0 */
  transition: max-height 0.3s, padding-bottom 0.3s;
  padding-bottom: 35px;
}

.categories span.active {
  color: #93cb53;
}

.categories span {
  margin-left: -3px;
  display: block;
  font-size: 16px;
  line-height: 26px;
  color: #666;
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
// .cap {
//   text-transform: capitalize;
// }
</style>
